export default __webpack_public_path__ + "assets/01n.a42b7aec.svg";